import {
  aLogMapping,
  anUpdateLogMappingEnabled,
  mockUpdateMappingEnabledOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockUpdateMappingEnabledOperationMutation(
    async ({ query: _query, variables }) => {
      await delay(1500);
      const { enabled } = variables;

      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          updateLogMappingEnabled: anUpdateLogMappingEnabled({
            data: aLogMapping({ isEnabled: enabled }),
          }),
        },
      });
    }
  ),
];
